import { Component, ViewChild } from '@angular/core';
import { LoginModalComponent } from './Modals/login-modal/login-modal.component';
import { SpinnerService } from '@backend/webapp/spinner/spinner.service';
import { LicenseModalComponent } from './Modals/license-modal/license-modal.component';

@Component({
    selector: 'backend-getting-started',
    templateUrl: './getting-started.component.html',
    styleUrls: ['./getting-started.component.css'],
    standalone: false
})
export class GettingStartedComponent {
  @ViewChild('loginModal')
  public loginModal: LoginModalComponent;

  @ViewChild('licenseModal')
  public licenseModal: LicenseModalComponent;

  constructor(public spinner: SpinnerService) {}

  public onLoginModalClick() {
    this.spinner.showSpinner();
    this.loginModal.open = true;
    this.spinner.hideSpinner();
  }

  public onLicenseModalClick() {
    this.spinner.showSpinner();
    this.licenseModal.open = true;
    this.spinner.hideSpinner();
  }
}
